<!--
 * @Author: awu
 * @Date: 2020-11-12 23:26:44
 * @LastEditors: awu
 * @LastEditTime: 2020-12-09 23:01:59
 * @Description: 交换名片
-->
<template>
    <div class="product">
        <div class="backHome" @click="backHome">
            <img src="../../assets/user/close.png" alt="" />
        </div>
        <h1>{{ card.h1 }}</h1>
        <div class="warpper">
            <p>{{ card.msg }}</p>
            <div class="out">
                <span class="circle" @click="clickFlag = !clickFlag" :class="{ active: clickFlag }">✓</span><span>{{ card.noCaution }}</span>
            </div>
            <div class="btnBox">
                <div @click="backHome">{{ card.btn1 }}</div>
                <div @click="exchangeCard">{{ card.btn2 }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import api from "@/api";
import { mapState } from "vuex";

export default {
    name: "AreaCard",
    data() {
        return {
            clickFlag: false,
            cardId: "",
            company_id: null,
            exhibition_id: 14
        };
    },
    mounted() {
        this.exhibition_id = this.$route.query.exhibition_id
        this.company_id = Number(this.$route.query.company_id);
        this.getExhibitor();
    },
    methods: {
        backHome() {
            this.$root.$emit("close");
            this.$emit("cancel", 5);
        },
        exchangeCard() {
            if(this.userInfo.id){
                api.exchangeCard({
                    exhibition_id: this.exhibition_id,
                    card_id: this.cardId
                }).then((res) => {
                    console.log(res);
                    if (res.res === 1) {
                        this.$message.success(res.mes);
                        this.backHome()
                    } else if (res.errCode == 20001) {
                        this.$store.commit("setState", {
                            showUserModal: true
                        });
                    }
                });
            }else{
                this.$message(
                    {
                        type: 'warning',
                        message: this.$t('area').loginTip
                    }
                )
                this.$router.push({
                    path: '/login'
                })
            }
            
        },
        getExhibitor() {
            api.getExhibitionDetali({
                id: this.company_id,
                params: {
                    exhibition_id: this.exhibition_id
                }
            }).then((res) => {
                if (res.res == 1) {
                    this.cardId = res.info.cards[0].id;
                    console.log(this.cardId)
                }
            });
        }
    },
    computed: {
        card() {
            return this.$t("card");
        },
        ...mapState(["userInfo","language"]),
    }
};
</script>

<style lang="scss" scoped>
.product {
    width: 667px;
    background-color: #ffffff;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-shadow: 0px 8px 10px 4px rgba(0, 0, 0, 0.3);
    border-radius: 30px;
    box-sizing: border-box;
    padding: 33px 0 43px 0;
    > h1 {
        height: 28px;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #5f7185;
        line-height: 28px;
        text-align: center;
        margin-bottom: 17px;
    }
    .warpper {
        width: 369px;
        margin: 0 auto;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #5f7185;
        line-height: 24px;
        .out {
            margin: 8px 0 31px 0;
            display: flex;
            align-items: center;
            .circle {
                width: 16px;
                height: 16px;
                background: #dfe8f9;
                color: #dfe8f9;
                box-shadow: 1px 3px 4px 0px rgba(0, 0, 0, 0.2), -1px -3px 4px 0px rgba(255, 255, 255, 0.4), 0px 0px 4px 3px rgba(255, 255, 255, 0.1);
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                margin-right: 7px;
            }

            .active {
                background: #09468c;
            }
        }
        .btnBox {
            width: 100%;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            > div {
                width: 120px;
                height: 40px;
                cursor: pointer;
                background: #a4b6cc;
                box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.3);
                border-radius: 20px;
                font-size: 16px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #ffffff;
                line-height: 40px;
                text-align: center;
            }
            div:last-of-type {
                margin-left: 20px;
                background: #09468c;
            }
        }
    }
}
.backHome {
    width: 33px;
    height: 33px;
    position: absolute;
    top: 21px;
    right: 21px;
    border-radius: 50%;
    > img {
        width: 100%;
        height: 100%;
    }
}
.backHome:hover {
    background-color: #e8eef4;
}
</style>



// WEBPACK FOOTER //
// src/views/card/index.vue